import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../utils/api';
import { postSupplierConfirmed } from '../../common/endpoints';

const initialState = {
  data: null,
  loading: false,
  error: null,
};

export const postSupplierConfirmation = createApi(postSupplierConfirmed, 'POST');

const supplierConfirmationSlice = createSlice({
  name: 'supplierConfirmation',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(postSupplierConfirmation.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(postSupplierConfirmation.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(postSupplierConfirmation.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default supplierConfirmationSlice.reducer;
